import { render, staticRenderFns } from "./ClubDetail.vue?vue&type=template&id=561532d9&scoped=true&"
import script from "./ClubDetail.vue?vue&type=script&lang=ts&"
export * from "./ClubDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ClubDetail.vue?vue&type=style&index=0&id=561532d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561532d9",
  null
  
)

export default component.exports